export type RouteName = "home" | "pricing" | "orders" | "order" | "legal" | "privacy" | "terms" | "refund" | "not-found";

export interface RouteDefinition {
  name: RouteName;
  path: string;
  title: string;
  description: string;
  public: boolean;
  indexable: boolean;
}

export const routeDefinitions: RouteDefinition[] = [
  { name: "home", path: "/", title: "图萃 · 1688 商品素材整理助手", description: "从 1688 商品页识别、分类并下载主图、视频、SKU 图和详情图。", public: true, indexable: true },
  { name: "legal", path: "/legal", title: "隐私与协议 · 图萃", description: "查看图萃隐私政策、用户协议和退款政策。", public: true, indexable: false },
  { name: "privacy", path: "/privacy", title: "隐私政策 · 图萃", description: "了解图萃如何在浏览器本地处理 1688 商品素材、选择状态和下载数据。", public: true, indexable: false },
  { name: "terms", path: "/terms", title: "用户协议 · 图萃", description: "了解图萃免费本地素材整理工具的服务内容、使用规则与责任边界。", public: true, indexable: false },
  { name: "refund", path: "/refund-policy", title: "退款政策 · 图萃", description: "图萃当前版本免费提供，不创建订单或收取费用。", public: true, indexable: false },
];

export function resolveRoute(pathname: string): RouteDefinition & { params: Record<string, string> } {
  const normalized = pathname !== "/" ? pathname.replace(/\/$/, "") : pathname;
  const exact = routeDefinitions.find((route) => route.path === normalized);
  if (exact) return { ...exact, params: {} };

  return {
    name: "not-found",
    path: normalized,
    title: "页面未找到 · 图萃",
    description: "此页面不存在或已移动。",
    public: true,
    indexable: false,
    params: {},
  };
}

export function publicAgreementPaths(): string[] {
  return routeDefinitions
    .filter((route) => route.public && ["privacy", "terms", "refund"].includes(route.name))
    .map((route) => route.path);
}

export function canonicalPath(route: Pick<RouteDefinition, "name" | "path">): string {
  if (route.path === "/") return "/";
  return ["legal", "privacy", "terms", "refund"].includes(route.name) ? `${route.path}/` : route.path;
}
